// extracted by mini-css-extract-plugin
export default {"melodyVideo":"hJ-z","isFullWidth":"iJ-z","landingPageVideo":"jJ-z","play":"kJ-z","iframeVideo":"lJ-z","playHidden":"mJ-z","fullwidth":"nJ-z"};